import { useTheme } from "@/context/ThemeContext";
import { useLanguage } from "@/context/LanguageContext";
import { supportLabels } from "@/i18n";

export const IfSomethingWrong = () => {
  const { theme } = useTheme();
  const { language } = useLanguage();
  const c = supportLabels(language).docGuideContent?.ifSomethingWrong ?? {};
  const isDark = theme === "dark";

  const items = [c.item1, c.item2, c.item3].filter(Boolean) as string[];

  return (
    <div className="space-y-4">
      <ul
        className={`text-sm space-y-2 ml-4 ${
          isDark ? "text-gray-300" : "text-gray-700"
        }`}
      >
        {items.map((item, j) => (
          <li key={j}>• {item}</li>
        ))}
      </ul>
      <p
        className={`text-sm leading-relaxed ${
          isDark ? "text-gray-300" : "text-gray-700"
        }`}
      >
        {c.bileniaHelp}
      </p>
    </div>
  );
};
